import { CustomButton } from "./custom-button";

export class CustomDialogWindow {
    title : string;
    message : string;
    buttons : CustomButton[];

    constructor(title? : string, message? : string, buttons? : CustomButton[]){
        this.title = title;
        this.message = message;
        this.buttons = buttons;
    }
}
